/**
 * _gst.js — Australian GST rate and inclusive/exclusive arithmetic.
 *
 * The single front-end owner of the 10% rate. Imported by
 * gst_calculator_controller.js (the original site of the literal) and
 * document_generator_controller.js. A second hardcoded 0.10 anywhere under
 * static/js is the bug this module exists to prevent, display strings included:
 * derive them from GST_RATE rather than writing "10%" by hand.
 *
 * Scope is the front end only. The server has its own owner in
 * application/constants/regions.py (REGIONS['AU']['tax_rate']), and the invoice
 * generator's PDF takes its numbers from InvoiceDraftService, never from a
 * total posted by this code. The browser figure is a live preview; the server
 * figure is the document.
 *
 * Not a *_controller.js file, so esm/index.js does not register it as a
 * Stimulus controller.
 */

export const GST_RATE = 0.10;

/** GST payable on a GST-exclusive amount. */
export function gstOnExclusive(exclusive) {
    return exclusive * GST_RATE;
}

/**
 * Split a GST-inclusive amount into the base it was built from and the GST
 * inside it. Returns { exclusive, gst }.
 */
export function gstFromInclusive(inclusive) {
    const exclusive = inclusive / (1 + GST_RATE);
    return { exclusive: exclusive, gst: inclusive - exclusive };
}
